"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkedErrorLogging = void 0;
/**
 * Utility class to log errors.
 * Install any error client package like lincd-sentry in your app to log errors.
 */
class LinkedErrorLogging {
    static setDefaultLogger(logger) {
        this.logger = logger;
    }
    static hasDefaultLogger() {
        return this.logger && true;
    }
    static log(error) {
        if (this.logger) {
            return this.logger.log(error);
        }
    }
}
exports.LinkedErrorLogging = LinkedErrorLogging;
//# sourceMappingURL=LinkedErrorLogging.js.map